import store from '@/store/index.js'
const router_domain_url = store.state.router_domain_url

// 异步请求处理
/**
 *
 * @param {路径} path
 * @param {组件路径} file
 * @param {别名，没有传null } name
 * @param {说明，没有就传{} } meta
 * @param {子级，没有子级可以不传} children
 */
function route(path, file, name, meta, children, redirect) {
  return {
    exact: true,
    path,
    name,
    meta,
    children,
    redirect,
    component: () => import(`@/views/customization/${router_domain_url}/pages/${file}`)
  }
}
const indexRouterlist = [
  route('/', 'yahoojp/Home', '', { title: '首页', ssr: true,  pageWidth: true, keepAlive: true, requireAuth: false }),
  route('/checkout-alternative', 'shop/CheckoutAlternative', 'CheckoutAlternative', { title: '提交订单', ssr: true,  pageWidth: true, keepAlive: true, requireAuth: false }),
  route('/sunList', 'sunSingle/sunList', 'sunList', { title: '购物体验', ssr: true,  pageWidth: true, keepAlive: true, requireAuth: false }),
  route('/sunLIstDail', 'sunSingle/sunLIstDail', 'sunLIstDail', { title: '体验详情', ssr: true,  pageWidth: true, keepAlive: true, requireAuth: false }),
  route('/sunListMe', 'sunSingle/sunListMe', 'sunListMe', { title: '个人晒单', ssr: true,  pageWidth: true, keepAlive: true, requireAuth: false }),
  route('/order-pay', 'Orders/orederPay', 'orederPay', { title: '支付订单', ssr: true,  pageWidth: true, keepAlive: true, requireAuth: false }),
  route('/for-pack-pay', 'Orders/ForPackPay', 'ForPackPay', { title: '支付国际运费', ssr: true, pageWidth: true, keepAlive: true, requireAuth: false }),
  route('/meiluGoodDetail', 'mercari/meiluGoodDetail', 'meiluGoodDetail', { title: '煤炉详情', ssr: true,  pageWidth: true, keepAlive: true, requireAuth: true }),
  route('/RakutenerGoodDetail', 'rakuten_old/RakutenerGoodDetail', 'RakutenerGoodDetail', { title: '乐天中古详情', ssr: true,  pageWidth: true, keepAlive: true, requireAuth: true }),
  route('/order-pay-self', 'Orders/orederPaySelf', 'orederPaySelf', { title: '支付订单', ssr: true,  pageWidth: true, keepAlive: true, requireAuth: false }),
  route('/cart', 'shop/Cart', 'Cart', { title: '购物车', ssr: true,  pageWidth: true, keepAlive: true, requireAuth: true }),
]
const personRouterlist = [
  route('/user', 'profile/ViewProfile', 'user', { title: '个人中心', ssr: true,  pageWidth: true, keepAlive: true, requireAuth: true }),
  route('/order-list-pack', 'Orders/OrderListPack', 'OrderListPack', { title: '转运包裹', ssr: true,  pageWidth: true, keepAlive: true, requireAuth: true }),
  route('/order-pack-details', 'Orders/OrderPackDetails', 'OrderPackDetails', { title: '转运包裹详情', ssr: true,  pageWidth: true, keepAlive: false, requireAuth: true }),
  route('/leave-message', 'Orders/leaveMessage', '', { title: '留言订单', ssr: true,  pageWidth: true, keepAlive: false, requireAuth: true }),
  route('/bargain-order', 'Orders/bargainOrder', '', { title: '议价订单', ssr: true,  pageWidth: true, keepAlive: false, requireAuth: true }),
]
export default {
  indexRouterlist: indexRouterlist,
  personRouterlist: personRouterlist,
}
